var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleDrive24 = function SvgGoogleDrive24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.36 17.712.795 1.364c.165.287.402.513.68.677l2.835-4.882H3c0 .318.082.636.247.923l1.114 1.918Z",
    fill: "#0066DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.128 9.165 4.246c-.278.164-.516.39-.68.677l-5.238 9.026c-.161.28-.247.599-.247.923h5.67L12 9.128Z",
    fill: "#00AC47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.166 19.753c.278-.164.515-.39.68-.677l.33-.564 1.577-2.718c.165-.287.248-.605.248-.923h-5.67l1.206 2.36 1.629 2.522Z",
    fill: "#EA4335"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m12 9.128 2.835-4.882A1.82 1.82 0 0 0 13.907 4h-3.814c-.33 0-.65.092-.928.246L12 9.128Z",
    fill: "#00832D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.33 14.871H8.67l-2.835 4.882c.278.164.598.246.928.246h10.474c.33 0 .65-.092.928-.246l-2.835-4.882Z",
    fill: "#2684FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m18.134 9.436-2.619-4.513a1.868 1.868 0 0 0-.68-.677L12 9.128l3.33 5.744h5.66c0-.318-.083-.636-.248-.923l-2.608-4.513Z",
    fill: "#FFBA00"
  })));
};
export default SvgGoogleDrive24;